import { z } from 'zod';
import { Auth0UserSchema } from '../../logStreamEvents/base/base.js';
export const GetRecordedUsersRequestSchema = z.void();
export const GetRecordedUsersResponseSchema = z.object({
    users: Auth0UserSchema.array(),
});
export const GetRecordedUsersApiSchema = {
    response: GetRecordedUsersResponseSchema,
};
